import Swal from "sweetalert2";
import api from "../../../utilities/interseptor";
const key = process.env.REACT_APP_CLAVE_INCRIPTACION;
const apiUrl = process.env.REACT_APP_API
export class ProgramacionDeServiciosIntegracion{
    static getOperadoresNoDispobles = (fecha,setOperadoresNoDisponibles)=>{
        api.get(`${apiUrl}/monitor/programacion/programar-servicios/get-operadores-no-disponibles?fecha=${fecha}`).then((res)=>{
     
            setOperadoresNoDisponibles(res.data)
            
        })
        .catch((error)=>{
            console.log("error",error);
        })
    }
    static getUnidadesNoDispobles = (fecha,setUnidadesNoDisponibles)=>{
        api.get(`${apiUrl}/monitor/programacion/programar-servicios/get-unidades-no-disponibles?fecha=${fecha}`).then((res)=>{
    
            setUnidadesNoDisponibles(res.data)
            
        })
        .catch((error)=>{
            console.log("error",error);
        })
    }

    static programar =  (data,programacionContadores)=>{
    
        Swal.fire({
            title: 'Cargando...',
            text: 'Este proceso puede tardar mas de 5 minutos',
            allowOutsideClick: false,  // Evita que el modal se cierre haciendo clic fuera
            allowEscapeKey: false,     // Evita que el modal se cierre con la tecla ESC
            didOpen: () => {
                Swal.showLoading();     // Muestra el spinner de carga
            }
        });
        api.post(`${apiUrl}/monitor/programacion/programar`,data).then((res)=>{
          
            Swal.close();
            if(res.data.message != 'success')
            {
                Swal.fire({
                    icon:'warning',
                    title: 'ups....',
                    text: res.data.message,

                });
            }
            programacionContadores(res.data)
            
        })
        .catch((error)=>{
            Swal.close();
            console.log("error",error);
        })
    }
}